<header>
  <div class="header-container">
    <h1  ><b>GRATULACJE!</b> TAK WYGLĄDA TWÓJ WYMARZONY DOM</h1>
    <p  >Przygotowaną kompozycję kolorystyczną możesz jeszcze uzupełnić tynkiem mozaikowym.</p>
  </div>
</header>

<main>
  <article>
    <img src="{{project.projectImageFile}}">
    <aside>
      <h1  >{{project.knaufPalette | palette}}</h1>
      <h3  >Wybrane kolory</h3>
      <ul *ngIf="project.selectedColors.length">
        <li *ngFor="let color of project.selectedColors"><span
            [ngStyle]="{'background': color.rgb}"></span>{{color.code}}</li>
      </ul>
      <h4 *ngIf="project.selectedColors.length == 0">Nie wybrałeś swoich kolorów.</h4>
    </aside>
  </article>
</main>
<app-footer [nextEvent]="true" [prev]="prev" (clickNext)="onNextClick($event)"></app-footer>

<jw-modal id="quest-mosaic-dlg">
  <div class="questmosaicdlg messagebox">
    <button class="dlg-closebutton"><img src="assets/ikony/aplikacja-ikony-18.png"    alt="Zamknij"
        (click)="closeModal()"></button>
    <p>Czy chcesz dodatkowo wybrać tynk mozaikowy, który chroni
      przed uszkodzeniem i zabrudzeniem cokoły, szczyty i naroża
      fasad oraz do strefy wejściowej?</p>
    <div class="buttons">
      <button class="btn-success btn accept" (click)="accept()">
       Tak
      </button>
      <button class="decline btn btn-light" (click)="decline()">
        Nie
      </button>
    </div>
  </div>
</jw-modal>
